$(document).ready(function(){
var swatchAlt= $('[name="Size"]:checked').val();
    if(swatchAlt != undefined){
   swatchAlt = swatchAlt.toLowerCase().replace(/ /g, '');  
   thumbImagesmobile(swatchAlt); 
}
  $('body').on('click','.variant_image_def',function(){
     var swatchAlt =$(this).attr('media-alt');
    if(swatchAlt!=undefined){
      swatchAlt = swatchAlt.toLowerCase().replace(/ /g, '').trim();
    thumbImagesmobile(swatchAlt);
    }
  }) 
function thumbImagesmobile(swatchAlt){
     $('.def_thumbnail_img').each(function(){
     var media_alt =$(this).attr('media-alt').toLowerCase().replace(/ /g, '').trim();
     // console.warn(swatchAlt+'/'+media_alt);
     if(media_alt==swatchAlt){
      $(this).show();
      $(this).addClass('single-image-selected');
      }
      else{
       $(this).hide();
      $(this).removeClass('single-image-selected');
      }
   }).promise().done(function(){
        setTimeout(function(){
        $('.single-image-selected').eq(0).find('button').click();
             }, 1);
     })
}
})
